import { render, staticRenderFns } from "./trial-message.vue?vue&type=template&id=7b67c73a&scoped=true&"
import script from "./trial-message.vue?vue&type=script&lang=js&"
export * from "./trial-message.vue?vue&type=script&lang=js&"
import style0 from "./trial-message.vue?vue&type=style&index=0&id=7b67c73a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b67c73a",
  null
  
)

export default component.exports